
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    // trapFocus(this, this.querySelector('[role="dialog"]'));
    // window.pauseAllMedia();
  }

  hide() {
    console.log('hide function run');
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    var existingScripts = document.head.querySelectorAll('.custom-flickity-script');
      if (existingScripts.length > 0) {
        existingScripts.forEach(function (script) {
          script.parentNode.removeChild(script);
        });
      }
    // removeTrapFocus(this.openedBy);
    // window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);


class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);




if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('div[id^="template-product"]');
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;
        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
       const dataUpdater = new DataUpdater('.quick-add-modal__content-info .selector-wrapper');
       const quantityselector = new QuantitySelector('.quick-add-modal__content-info .quantity__plus','.quick-add-modal__content-info .quantity__minus');

         openTabs();
        
        // getVariantFromSerializedArray();
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        // const product = this.modalContent.querySelector('.product');

        // Get all elements with the data-src attribute
var elementsWithDataSrc = this.modalContent.querySelectorAll('img[data-src]');

elementsWithDataSrc.forEach(function (element) {
  var dataSrcValue = element.getAttribute('data-src');

  // Check if next sibling exists before trying to set its attribute
  if (element.nextElementSibling) {
    element.nextElementSibling.setAttribute('src', dataSrcValue);
  }

  // Remove the data-src attribute if needed
  // element.removeAttribute('data-src');
});


        // const desktopColumns = product.classList.contains('product--columns');
        // if (!desktopColumns) return;

        // const mediaImages = product.querySelectorAll('.product__media img');
        // if (!mediaImages.length) return;

        // let mediaImageSizes =
        //   '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        // if (product.classList.contains('product--medium')) {
        //   mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        // } else if (product.classList.contains('product--small')) {
        //   mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        // }

        // mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}

class DataUpdater {
  constructor(selector) {
    this.selector = selector;
    this.initialize();
  }
  initialize() {
    const elements = document.querySelectorAll(this.selector);
    elements.forEach(element => {
      element.addEventListener('change', this.onVariantChange);
    });
  }
  onVariantChange(event) {
     var options = Array.from(this.querySelectorAll('fieldset input:checked'), (select) => select.value);
     this.getVariantData =  JSON.parse(this.closest('.quick-add-modal__content-info').querySelector('[data-product-json]').textContent);
      this.currentVariant = this.getVariantData.variants.find((variant) => {
          return variant.options.every((option, index) => options[index] === option);
      });
      // update master id
      this.closest('form').querySelector("[name='id']").setAttribute('value',this.currentVariant.id);
      // disable button if variant not available
     if(!this.currentVariant){
        this.closest('form').querySelector('button[name="add"]').setAttribute('disabled', 'disabled');
     }else{
        this.closest('form').querySelector('button[name="add"]').removeAttribute('disabled', 'disabled');
     } 
  }
}
class QuantitySelector {
  constructor(plus,minus) {
    this.plus = plus;
    this.minus = minus;
    this.initialize();
  }
  initialize() {
   // plus function
    const plusElements = document.querySelectorAll(this.plus);
    plusElements.forEach(element => {
      element.addEventListener('click', this.plusNumber);
    });
    // minus function
    const minusElements = document.querySelectorAll(this.minus);
    minusElements.forEach(element => {
      element.addEventListener('click', this.minusNumber);
    });
  }
  // plus function define
  plusNumber(event) {
     var quantityElement = this.closest('.quantity-selector').querySelector('.quantity__input');
      var quantity = parseInt(quantityElement.getAttribute('value'),10);
      if( quantity < 1) return;
      quantityElement.setAttribute('value',quantity+1)
  }
  // minus function define
  minusNumber(event) {
     var quantityElement = this.closest('.quantity-selector').querySelector('.quantity__input');
      var quantity = parseInt(quantityElement.getAttribute('value'),10);
      if( quantity == 1 || quantity < 1) return;
      quantityElement.setAttribute('value',quantity-1)
  }
}
function openTabs(){
     var script = document.createElement('script');
     script.className = 'custom-flickity-script';
    script.src = 'https://unpkg.com/flickity@2/dist/flickity.pkgd.min.js';
    script.onload = function () {
      // Initialize Flickity carousel
          // Initialize Flickity carousel
// Initialize Flickity carousel
var mainCarousel = new Flickity('.product__slides', {
  // Add your other main carousel options here
  adaptiveHeight: true
});
    };
    document.head.appendChild(script);

  var coll = document.querySelectorAll(".accordion-row");

coll.forEach(function(element) {
  element.addEventListener("click", function() {
    this.querySelector('.accordion-toggle').classList.toggle("is-open");
    var content = this.querySelector('.accordion-content');
    if (content.style.maxHeight) {
      content.style.maxHeight = null;
      content.style.display = 'none';
    } else {
      content.style.display = 'block';
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
});


    
}